import Image from "next/image";
import React from "react";

const CalendarButton = ({ setIsOpenModal }) => {
  return (
    <button
      onClick={() => setIsOpenModal(true)}
      type="button"
      className="flex items-center justify-center bg-white rounded-full w-9 h-9 "
    >
      <div className="relative w-4 h-4">
        <Image
          src="/icons/card-calendar.svg"
          alt="card-calendar"
          fill
          className="object-cover"
        />
      </div>
    </button>
  );
};

export default CalendarButton;
